export const LOGIN = '/login'
export const PRODUCT = '/product'
export const BARCODE = '/barcode'
export const HERO = '/hero'
export const BRAND = '/brand'
export const BRAND_NEWS = '/brand-news'
export const BRAND_COVER = '/brand-cover'
export const BIN = '/bin'
export const PRODUCT_FEATURE = '/product-feature'
export const ANNOUNCEMENT = '/announcement'
export const LOCATION = '/location'
export const HERO_NEWS_ITEM = '/hero-news-item'



// WEBPACK FOOTER //
// ./src/api/EndPoints.js